import React from "react";
import { getFeaturedPost } from "../../blog/data/blogData/BlogData";
import "./../../../../assets/css/general/blog/FeaturedPost/FeaturedPost.css";

const FeaturedPost = () => {
  const post = getFeaturedPost(); // ✅ Featured post automatically milega

  return (
    <section className="featured-section">
      <div className="featured-container">
        <div className="featured-header">
          <h2 className="featured-section-title">
            Featured <span className="featured-section-prefix">Article</span>
          </h2>
        </div>

        <div className="featured-card">
          <div className="featured-image-wrapper">
            <img src={post.image} alt={post.title} className="featured-image" />
          </div>

          <div className="featured-content">
            <span className="featured-badge">{post.category}</span>

            <h3 className="featured-title">{post.title}</h3>

            <p className="featured-description">{post.description}</p>

            <div className="featured-meta">
              <div className="featured-author">
                <div className="author-avatar">
                  <img
                    src={post.authorImage}
                    alt={post.author}
                    className="avatar-image"
                  />
                </div>
                <span className="author-name">By {post.author}</span>
              </div>

              <div className="featured-stats">
                <span className="stat-item">{post.readTime} read</span>
                <span className="stat-divider">•</span>
                <span className="stat-item">{post.date}</span>
              </div>
            </div>

            <button type="button" className="featured-cta">
              Read Full Article →
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedPost;
